<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title v-if="taxRegistration">
            {{ taxRegistration.tax.name }}
        </template>

        <template v-slot:header v-if="taxRegistration">
            <div class="row mb-0">
                <div class="col">
                    <span class="text-muted">
                        {{ taxRegistration.tax.type_pretty }}
                    </span>
                </div>
            </div>
            <!-- Tabs -->
            <div class="nav-tabs-container">
                <div class="nav-tabs-scroll-helper">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link" :class="{active: activeTab == 'main'}" href="#tabEarningContentMain" id="tabEarningLinkMain" data-toggle="tab" role="tab" aria-controls="tabEarningContentMain" :aria-selected="activeTab == 'main'">Main</a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <slot>
            <div class="tab-content" v-if="taxRegistration">
                <div class="tab-pane" :class="{'show active': activeTab == 'main'}" id="tabEarningContentMain" role="tabpanel" aria-labelledby="tabEarningLinkMain">
                    <!-- Positions widget -->
                    <info-widget :collapsible="false">
                        <template v-slot:title>Company Tax Registration</template>

                        <template v-slot:headerbutton>
                            <button type="button" class="btn btn-outline-primary" @click.prevent="editModalOpen = true">
                                <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                                Edit
                            </button>
                        </template>

                        <slot>
                            <div class="card-body py-1 mt-1">
                                <div class="mui-textfield">
                                    <span class="textfield">{{ taxRegistration.filing_id }}</span>
                                    <label>Filing ID</label>
                                </div>

                                <div class="mui-textfield">
                                    <span class="textfield">{{ taxRegistration.is_exempt ? 'Yes' : 'No' }}</span>
                                    <label>Is Exempt?</label>
                                </div>

                                <div class="mui-textfield" v-for="field in additionaValues">
                                    <span class="textfield">{{ field.value }}</span>
                                    <label>{{ field.label }}</label>
                                </div>

                            </div>
                        </slot>
                    </info-widget>
                </div>
            </div>
        </slot>

        <form-modal
            v-if="editModalOpen"
            :tax-registration="taxRegistration"
            :client="client"
            @updated="onUpdate"
            @close="editModalOpen = false"
        />
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import InfoWidget from '@/components/InfoWidget'
import ButtonRow from '@/components/ButtonRow'
import FormModal from './FormModal'

export default {
    props: ['taxRegistrationId', 'client', 'tab', ],
    components: {Sidebar, InfoWidget, ButtonRow, FormModal},
    computed: {
        additionaValues() {
            const result = []

            this.taxRegistration.tax.current_version.employer_specific_fields.forEach(field => {
                const answer = this.taxRegistration.company_tax_registration_additional_values.find(val => val.name == field.name)
                let prettyValue = answer.raw_value

                if (field.type == 'boolean') {
                    prettyValue = answer.raw_value ? 'Yes' : 'No'
                }
                else if (field.type == 'rate') {
                    prettyValue = `${answer.raw_value}%`
                }
                else if ((field.type == 'string') && (field.options)) {
                    const opt = field.options.find(o => o.value == answer.raw_value)
                    if (opt) {
                        prettyValue = opt.text
                    }
                }

                result.push({
                    label: field.label,
                    name: field.name,
                    type: field.type,
                    raw_value: answer.raw_value,
                    value: prettyValue,
                })
            })

            return result
        },
    },
    data() {
        return {
            taxRegistration: null,
            activeTab: this.tab || 'main',
            editModalOpen: false,
        }
    },
    watch: {
        taxRegistrationId() {
            this.getData()
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.taxRegistration = null
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/tax-registrations/${this.taxRegistrationId}`).then(resp => {
                this.taxRegistration = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        editPositions() {
            this.editPositionsModalOpen = true
        },
        onUpdate(obj) {
            if (this.taxRegistration) {
                Object.assign(this.taxRegistration, obj)
            }
            this.$emit('updated')
        },
    },
}
</script>

